import { render } from "./ModalShoppingList.vue?vue&type=template&id=0dec6246&scoped=true"
import script from "./ModalShoppingList.vue?vue&type=script&lang=js"
export * from "./ModalShoppingList.vue?vue&type=script&lang=js"

import "./ModalShoppingList.vue?vue&type=style&index=0&id=0dec6246&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec6246"]])

export default __exports__